import {
  CUSTOMER_SERVICE_HOURS,
  CUSTOMER_SERVICE_PHONE_NUMBER,
} from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Box, Stack, Heading } from 'braid-design-system';
import type React from 'react';

import { getSite } from 'src/config';

import translations from './.vocab';
import Error from './Error';

interface Props {
  message?: string;
}

const PageError: React.FunctionComponent<Props> = ({ message }) => {
  const { t } = useTranslations(translations);

  const site = getSite();

  type CustomerService = keyof typeof CUSTOMER_SERVICE_PHONE_NUMBER;

  // TODO: Make sure Asia sites are address later
  const renderDefaultMessage = () =>
    t('Something went wrong', {
      phoneNumber: CUSTOMER_SERVICE_PHONE_NUMBER[site as CustomerService],
      localeTime: CUSTOMER_SERVICE_HOURS[site as CustomerService],
    });

  const errorMessage = message || renderDefaultMessage();

  return (
    <Box marginX="gutter" marginY={['none', 'xxlarge']}>
      <Stack space="medium">
        <Heading component="h2" level="3">
          {t('An Error Occurred')}
        </Heading>
        <Error message={errorMessage} />
      </Stack>
    </Box>
  );
};

export default PageError;
